import * as React from 'react';
import { UseFormReturn } from 'react-hook-form';

import SaveStatus from '../../../../core/components/SaveStatus.tsx';
import SettingsFormCard from '../../../../core/components/SettingsFormCard.tsx';
import classnames from '../../../../core/utils/classnames.tsx';
import countFieldErrors from '../../../../core/utils/countFieldErrors.ts';

interface AssistantTabFormProps {
    title: string;
    description: string;
    form: UseFormReturn<any>;
    onSubmit: (event?: React.BaseSyntheticEvent) => Promise<unknown>;
    isSubmitting: boolean;
    isValid: boolean;
    children: React.ReactNode;
}

const AssistantTabForm = ({
    title,
    description,
    form,
    onSubmit,
    isSubmitting,
    isValid,
    children,
}: AssistantTabFormProps) => (
    <SettingsFormCard
        onSubmit={onSubmit}
        title={title}
        description={description}
        footer={
            <SaveStatus
                isDirty={form.formState.isDirty}
                isSubmitting={isSubmitting}
                errorCount={countFieldErrors(form.formState.errors)}
                isDisabled={!isValid}
            />
        }
    >
        {children}
    </SettingsFormCard>
);

interface TabSectionProps extends Omit<React.ComponentPropsWithRef<'section'>, 'title'> {
    title: React.ReactNode;
    titleAddon?: React.ReactNode;
    description?: React.ReactNode;
    titleClassName?: string;
    descriptionClassName?: string;
}

export const TabSection = ({
    title,
    titleAddon,
    titleClassName,
    description,
    descriptionClassName,
    className,
    children,
    ...props
}: TabSectionProps) => (
    <section {...props} className={classnames('flex flex-col gap-2', className)}>
        <div className="flex items-center gap-1">
            <h3 className={classnames('m-0 text-sm font-medium text-content-medium', titleClassName)}>{title}</h3>
            {titleAddon}
        </div>
        {description && (
            <p className={classnames('m-0 text-sm text-content-medium', descriptionClassName)}>{description}</p>
        )}
        <div className="flex flex-col gap-2">{children}</div>
    </section>
);

export default AssistantTabForm;
